import { createBrowserRouter } from "react-router-dom";
import MainPage from "../pages/MainPage";
import HomePage from "../pages/HomePage";
import TramitePage from "../pages/TramitePage";
import TramiteForm from "../components/TramiteForm";
import { ListadoTramitesPage } from "../pages/ListadoTramitesPage";

export const ruotes = [
  {
    path: "/",
    element: <MainPage />,
    children: [
      { path: "", element: <HomePage /> },
      {
        path: "tramite/:numero/",
        element: <TramitePage />,
        children: [{ path: "", element: <TramiteForm /> }],
      },
      {
        path: "reportes/tramites",
        children: [{ path: "", element: <ListadoTramitesPage /> }],
      },
    ],
  },
];

const Router = createBrowserRouter(ruotes);

export default Router;
